import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMyDatePickerModule, UtilService } from '@nodro7/angular-mydatepicker';
import { DatePickerOverlayComponent } from './date-picker-overlay.component';
import { DatePickerComponent } from './date-picker.component';
import { DatePickerConfig } from './date-picker.config';
import { TimePickerComponent } from './time-picker.component';
import { TimeComponent } from './time.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMyDatePickerModule,
        OverlayModule
    ],
    declarations: [
        DatePickerComponent,
        TimePickerComponent,
        DatePickerOverlayComponent,
        TimeComponent
    ],
    providers: [ DatePickerConfig, UtilService ],
    exports: [
        DatePickerComponent,
        TimePickerComponent,
        TimeComponent
    ]
})
export class DatePickerModule {
    public static forRoot(): ModuleWithProviders<DatePickerModule> {
        return { ngModule: DatePickerModule, providers: [DatePickerConfig] };
    }
}
